import downloadIcon from "@assets/images/download-teal.svg";
import { Button } from "@material-ui/core";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import { useExportExcelUploadTemplateMutation } from "@saleor/graphql";
import { sectionNames } from "@saleor/intl";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";
import { useIntl } from "react-intl";

import ExcelUploadFilter from "../components/excelUploadFilter";

const useStyles = makeStyles(
  {
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        marginBottom: "1.2rem"
      }
    },
    button: {
      minWidth: "16.4rem",
      "& img": {
        marginRight: ".8rem"
      }
    }
  },
  { name: "excelUpload" }
);

const ExcelUpload = () => {
  const intl = useIntl();
  const classes = useStyles();

  const [
    exportExcelUploadTemplateMutation,
    { loading }
  ] = useExportExcelUploadTemplateMutation();

  const handleDownloadTemplate = async () => {
    try {
      const { data } = await exportExcelUploadTemplateMutation();
      if (data?.exportExcelUploadTemplate) {
        const { exportedFileBase64, fileName } = data.exportExcelUploadTemplate;
        downloadBase64File(exportedFileBase64, fileName);
      }
    } catch (error) {
      console.error("Error exporting template:", error);
    }
  };

  const downloadBase64File = (base64String, fileName) => {
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Container>
      <PageHeader
        title={intl.formatMessage(sectionNames.excelUpload)}
        className={classes.pageHeader}
      >
        <Button
          variant="outlined"
          color="secondary"
          className={classNames(classes.button, "defaultB")}
          onClick={handleDownloadTemplate}
          disabled={loading}
        >
          <img src={downloadIcon} alt="Download Template" />
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "Download Template" })}
          </MyTypography>
        </Button>
      </PageHeader>
      <ExcelUploadFilter />
    </Container>
  );
};

export default ExcelUpload;
